import { render } from "./PartnerTilt.vue?vue&type=template&id=5ba52916"
import script from "./PartnerTilt.vue?vue&type=script&lang=js"
export * from "./PartnerTilt.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__